// @ts-check
// Module core/location-hash
// Resets window.location.hash to jump to the right point in the document

export const name = "core/location-hash";

export function run() {
  if (!location.hash) {
    return;
  }
  document.respec.ready.then(() => {
    let hash = decodeURIComponent(location.hash).substr(1);
    const hasLink = document.getElementById(hash);
    const isLegacyFrag = /\W/.test(hash);
    // Allow some degree of recovery for legacy fragments format.
    // See https://github.com/w3c/respec/issues/1353
    if (!hasLink && isLegacyFrag) {
      const id = hash
        .replace(/[\W]+/gim, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
      if (document.getElementById(id)) {
        hash = id;
      }
    }
    location.hash = `#${hash}`;
  });
}
